import React, { Suspense, useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    Switch,
    Route,
    Redirect,
    useRouteMatch
} from "react-router-dom";
import Loadable from "react-loadable";

// import { _fetch } from "../helpers/_fetch";
import ProfileAPI from "../api/profileAPI";

import swal from "sweetalert";
import { Avatar } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";

import { items, color } from "../helpers/constant";
import {
    closeSnackbar,
    closeSideDrawer,
    setProfile
} from "../actions/GeneralAction/general";
import UiContext from "../context/UiContext";
import Loading from "../components/Loading";

import Account from "./Account";
import Footer from "./Footer";
import Main from "./Main";
import SideBar from "./SideBar";
import Navigation from "./SideBar/Navigation";
import NavigationList from "./SideBar/NavigationList";
import SideToolbar from "./SideBar/SideToolbar";

import ChangePasswordModal from "../screens/Authentication/changePasswordModal";

const Dashboard = Loadable({
    loader: () => import("../screens/Dashboard"),
    loading: Loading
});

const Tenant = Loadable({
    loader: () => import("../screens/Tenant"),
    loading: Loading
});

const Credit = Loadable({
    loader: () => import("../screens/Credit"),
    loading: Loading
});

const User = Loadable({
    loader: () => import("../screens/User"),
    loading: Loading
});

const Maintance = Loadable({
    loader: () => import("../containers/Maintenance"),
    loading: Loading
});

const UserManagement = Loadable({
    loader: () => import("../screens/UserManagement"),
    loading: Loading
});

function MainLayout(props) {
    const {
        location,
        profile,
        setProfile,
        showSideDrawer,
        showSnackbar,
        snackbarMessage,
        snackbarSeverity,
        closeSnackbar
    } = props;

    let match = useRouteMatch();

    const [showChangePassword, setShowChangePassword] = useState(false);
    const [sidebarVisible, setSidebarVisible] = useState(true);
    const [footerHeight, setFooterHeight] = useState(0);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [menuVisibleMobile, setMenuVisibleMobile] = useState(false);

    const data = [
        { targetUrl: "https://twitter.co.id", title: "Twitter" },
        { targetUrl: "https://facebook.co.id", title: "Facebook" },
        { targetUrl: "https://google.co.id", title: "Google" },
        { targetUrl: "https://gmail.co.id", title: "Gmail" }
    ];

    const value = {
        sidebarVisible,
        setSidebarVisible,
        footerHeight,
        setFooterHeight,
        headerHeight,
        setHeaderHeight
    };

    const toggleChangePassword = () => {
        setShowChangePassword(prevState => !prevState);
    };

    useEffect(() => {
        ProfileAPI.getMe()
            .then(res => {
                let result = res.data;

                setProfile({
                    ...result,
                    permissions: [result.role]
                });

                if (result.forceSetPassword) {
                    toggleChangePassword();
                }
            });
    }, [setProfile]);

    const toggleSidebarVisible = () => {
        setSidebarVisible(prevState => !prevState);
    };

    const toggleMenuVisibleMobile = () => {
        setMenuVisibleMobile(prevState => !prevState);
    };

    const SwallMessage = (message, severity) => {
        swal({
            title: message,
            icon: severity,
            timer: 1800
        });

        closeSnackbar();
    };

    const renderAccountDetails = () => (
        <div
            style={{
                display: "flex",
                flexDirection: "column"
            }}
        >
            <Account user={profile} />
        </div>
    );

    if (location.pathname === "/") {
        return <Redirect to={"/dashboard"} />;
    }

    return (
        <Suspense fallback={"...loading"}>
            <>
                <CssBaseline />

                <SideBar
                    sidebarVisible={sidebarVisible}
                    menuVisibleMobile={menuVisibleMobile}
                    toggleSidebarVisible={toggleSidebarVisible}
                    toggleMenuVisibleMobile={toggleMenuVisibleMobile}
                >
                    <SideToolbar
                        apps={data}
                        logo={<Avatar />}
                        backgroundColor={color.darkGrey}
                        // appSwitcherEnabled={true}
                        // renderTopActions={renderTopActions}
                        renderAccountDetails={renderAccountDetails}
                    />

                    <Navigation
                        companyName="TalentClub Admin"
                        companyNameTooltip="TalentClub Admin"
                        sidebarVisible={sidebarVisible}
                    >
                        <NavigationList items={items} />
                    </Navigation>
                </SideBar>

                <Main
                    sidebarVisible={sidebarVisible}
                    sideDrawerVisible={showSideDrawer}
                >
                    <UiContext.Provider value={value}>
                        <Switch>
                            <Route path={`${match.url}dashboard`}>
                                <Dashboard />
                            </Route>

                            <Route path={`${match.url}tenant`}>
                                <Tenant />
                            </Route>

                            <Route path={`${match.url}credit`}>
                                <Credit />
                            </Route>

                            <Route path={`${match.url}user`}>
                                <User />
                            </Route>

                            <Route path={`${match.url}maintenance`}>
                                <Maintance />
                            </Route>

                            <Route path={`${match.url}user-management`}>
                                <UserManagement />
                            </Route>
                        </Switch>

                        <Footer />
                    </UiContext.Provider>
                </Main>

                {showChangePassword && (
                    <ChangePasswordModal
                        open={showChangePassword}
                        forceSetPassword={profile.forceSetPassword}
                        onHide={toggleChangePassword}
                    />
                )}

                {showSnackbar && SwallMessage(
                    snackbarMessage,
                    snackbarSeverity
                )}
            </>
        </Suspense>
    );
}

const mapStateToProps = state => ({
    profile: state.general.profile,
    showSnackbar: state.general.showSnackbar,
    snackbarPosition: state.general.snackbarPosition,
    snackbarSeverity: state.general.snackbarSeverity,
    snackbarMessage: state.general.snackbarMessage,
    showSideDrawer: state.general.showSideDrawer
});

const mapDispatchToProps = dispatch => ({
    setProfile: profile => {
        dispatch(setProfile(profile));
    },
    closeSnackbar: () => {
        dispatch(closeSnackbar());
    },
    closeSideDrawer: () => {
        dispatch(closeSideDrawer());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);